<template>
  <zl-dialog class="zl-saas" title="报价详情" ref="dialog" >
    <el-tabs value="first">
      <el-tab-pane label="报价清单" name="first">
        <baoJiaList :showPrice="showPrice" :row="row" :fileId="fileId" />
      </el-tab-pane>
      <el-tab-pane label="报价记录" name="second">
        <baoJiaRecord :row="row" />
      </el-tab-pane>
      <!-- <el-tab-pane label="谈判报价" name="third">
        <tanPanBaoJia :row="row" />
      </el-tab-pane>
      <el-tab-pane label="谈判记录" name="fourth">
        <tanPanRecord :row="row" />
      </el-tab-pane> -->
    </el-tabs>
  </zl-dialog>
</template>
<script>
import baoJiaList from '../component/baoJiaList.vue'
import baoJiaRecord from '../component/baoJiaRecord.vue'
// import tanPanBaoJia from '../component/tanPanBaoJia.vue'
// import tanPanRecord from '../component/tanPanRecord.vue'
import { isEmpty } from 'lodash-es'
export default {
  components: {
    baoJiaList,
    baoJiaRecord
    // tanPanBaoJia,
    // tanPanRecord
  },
  data() {
    return {
      isEmpty,
      row: {},
      fileId: '',
      showPrice: true
    }
  },
  methods: {
    open(args) {
      this.row = args.row
      this.showPrice = args.showPrice
      this.fileId = args.fileId
      return this.$refs.dialog.open()
    },
    cancel() {
      this.$refs.dialog.cancel()
    },
    confirm() {
      this.$refs.dialog.close()
    }
  }
}
</script>
